export default __webpack_public_path__ + "static/media/avatar.a9187376.jpg";